import { Location } from './../../../../shared/classes/location';
import { PickUpPointService } from './../pick-up-point.service';
import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/components/loading/loading.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-pick-up-point-index',
  templateUrl: './pick-up-point-index.component.html',
  styleUrls: ['./pick-up-point-index.component.css']
})
export class PickUpPointIndexComponent implements OnInit {

  pageTitle = "Pickup Points";
  pickupPoints: any;
  deletedItem: any;

  constructor(
    private pickup: PickUpPointService,
    public preLoader: LoadingService,
    private title: Title
  ) { }

  ngOnInit(): void {
    // Set nrower tab title
    this.title.setTitle(this.pageTitle);

    // Fetch customer list from serve
    this._getPickupPoints();
  }

  refresh() {
    this._getPickupPoints(); 
  }


  delete(pickupPoint: Location) {
    this.pickup.deletePickupPoint$(pickupPoint._id).subscribe(_ => {
        this.refresh();
      }
    );
  }

  private _getPickupPoints() {
    this.pickup.getPickupPoints$().subscribe(pickupPoints => {
      // Fetch list of pickup points from server
      this.pickupPoints = pickupPoints;
    });
  }

}
